<template>
  <div class="auth">
    <component-layout
      :type="this.type"
      v-on:toggle-type="toggle"
    ></component-layout>
    <componentModal/>
  </div>
</template>

<script>
// import componentLayout from './../components/auth/Layout.vue'
import componentLayout from './../components/auth2/Layout.vue'
import componentModal from './../components/dash/modalPopup.vue'
import { EventBus } from '@/event-bus'

export default {
  name: 'auth',

  components: {
    componentLayout,
    componentModal
  },

  beforeCreate() {
    // Handle OAuth callbacks that arrive without hash or with hash at the end (LinkedIn)
    // LinkedIn redirects to /?code=XXX#/ but Vue router needs /#/?code=XXX
    const search = window.location.search
    const hash = window.location.hash
    const hasCode = search.includes('code=')

    // Check if code is in search params but not properly in hash router format
    if (hasCode && (hash === '' || hash === '#/' || !hash.includes('?'))) {
      // OAuth callback - need to move search params into hash router
      window.location.href = `${window.location.origin}/#/${search}`
      return
    }

    if (localStorage.user) {
      this.$router.push({
        name: 'dash'
      })
    } else document.body.classList.remove('dash')
  },

  mounted() {
    if (this.$route.query.ref === 'demo' && localStorage.getItem('demo/pendingDraft')) {
      EventBus.$emit(
        'showModal',
        this.$t('dash.demo.signup-popup.title'),
        this.$t('dash.demo.signup-popup.subtitle'),
        '',
        this.$t('dash.demo.signup-popup.close'),
        () => {},
        () => {},
        null,
        true // disableClickOutside - this page's cookie-consent (CMP) widget renders its own
             // overlay; clicking it would otherwise count as an "outside click" and close this
      )
    }

    let scriptCMP1 = document.createElement('script')
    scriptCMP1.setAttribute(
      'src',
      'https://cache.consentframework.com/js/pa/21964/c/lIACl/stub'
    )
    document.head.appendChild(scriptCMP1)

    let scriptCMP2 = document.createElement('script')
    scriptCMP2.setAttribute(
      'src',
      'https://choices.consentframework.com/js/pa/21964/c/lIACl/cmp'
    )
    scriptCMP2.setAttribute('async', 'true')
    document.head.appendChild(scriptCMP2)
  },

  data() {
    return {
      type: this.$route.query.ref === 'demo' ? 'signup' : 'login'
      // type: 'signup'
    }
  },

  methods: {
    /**
     * Change type to display signup or login layout
     */
    toggle(type) {
      this.type = type
    }
  }
}
</script>
